import {
  EvListFilteredValueType,
  EvListFilteredType,
  EvListConfigTypeType,
  EvListConfigType,
  EvListParams,
  EvListReturnType,
  EvListFunction,
} from './ev-list.models';
import {useErpUiRouterContext} from '../use-erp-ui-router-context';
import {NumberHelper} from '../../../helper/number-helper';
import {
  EvCurrentUiRouterParameters,
  EvCurrentUiRouterParameterValueType,
} from '../../components/react-router/erp-react-router-context';
import {useState} from 'react';

function cleanParameter(
  value: EvCurrentUiRouterParameterValueType,
  type: EvListConfigTypeType,
): EvListFilteredValueType {
  switch (type) {
    case 'boolean':
      if (typeof value === 'boolean') {
        return value;
      } else if (typeof value === 'string') {
        return value === 'true';
      }
      break;
    case 'int':
      if (typeof value === 'number') {
        return value;
      } else if (typeof value === 'string') {
        return NumberHelper.saveParseInteger(value);
      }
      break;
    case 'string':
      if ((value?.toString() ?? '') !== '') {
        return value?.toString();
      }
      break;
  }

  return null;
}

function cleanParameters(
  values: EvCurrentUiRouterParameters,
  config: EvListConfigType,
): EvListFilteredType {
  return Object.keys(config.types).reduce((acc, key) => {
    acc[key] = cleanParameter(values[key], config.types[key]);
    return acc;
  }, {} as EvListFilteredType);
}

export function useEvListFilterHook<T>({stateName, config}: EvListParams): EvListReturnType<T> {
  const location = useErpUiRouterContext();
  const [state, setState] = useState<{ params: EvListFilteredType }>(() => {
    const params = cleanParameters(location.currentParameters, config);
    return {
      params: {page: (params.page ?? 1) as number, ...params},
    };
  });

  const formChanged: EvListFunction<T> = (form, options) => {
    const stateNew = {...state.params, ...form, page: options?.keepPage ? state.params.page : 1};
    location.routeAngular(stateName, cleanParameters(stateNew, config), {inherit: true}).catch(() => {
      console.error('Could not change parameters in list', stateName);
    });
    setState({...state, params: stateNew});
  };

  const pageChanged: (page: number) => void = (page) => {
    const stateNew = {...state.params, page: page};
    location.routeAngular(stateName, stateNew, {inherit: true}).catch(() => {
      console.error('Could not change page in list', stateName);
    });
    setState({...state, params: stateNew});
  };

  return {
    params: {...state.params, page: state.params.page ?? 1} as T,
    formChanged: formChanged,
    pageChanged: pageChanged,
  };
}
